import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutMeComponent } from './components/about-me/about-me.component';
import { AcademicComponent } from './components/academic/academic.component';
import { CapstoneComponent } from './components/capstone/capstone.component';
import { ProfessionalComponent } from './components/professional/professional.component';
import { NavigComponent } from './components/navig/navig.component';
import { FooterComponent } from './components/footer/footer.component';
import { ResumeCoverComponent } from './components/resume-cover/resume-cover.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    AboutMeComponent,
    AcademicComponent,
    CapstoneComponent,
    ProfessionalComponent,
    NavigComponent,
    FooterComponent,
    ResumeCoverComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
